var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinanceVendorMangEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.594,
    height: 23.594,
    viewBox: "0 0 23.594 23.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-1.5 -1.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9320",
    "data-name": "Path 9320",
    d: "M19.632,25.832H4.7a3.2,3.2,0,0,1-3.2-3.2V7.7A3.2,3.2,0,0,1,4.7,4.5h7.466a1.067,1.067,0,0,1,0,2.133H4.7A1.068,1.068,0,0,0,3.633,7.7V22.632A1.068,1.068,0,0,0,4.7,23.7H19.632A1.068,1.068,0,0,0,20.7,22.632V15.166a1.067,1.067,0,1,1,2.133,0v7.466A3.2,3.2,0,0,1,19.632,25.832Z",
    transform: "translate(0 -0.919)",
    fill: "#007d08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9321",
    "data-name": "Path 9321",
    d: "M24.365,1.318A3.329,3.329,0,0,1,26.72,7L16.587,17.134a1.067,1.067,0,0,1-.5.281l-4.266,1.067a1.067,1.067,0,0,1-1.293-1.293L11.6,12.921a1.067,1.067,0,0,1,.281-.5L22.011,2.293A3.307,3.307,0,0,1,24.365,1.318Zm-9.078,14.1,9.924-9.924A1.2,1.2,0,0,0,23.52,3.8L13.6,13.725l-.564,2.255Z",
    transform: "translate(-2.601)",
    fill: "#007d08"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceVendorMangEditIcon);
export default __webpack_public_path__ + "static/media/finance-vendor-mang-edit-icon.b3140d25644801ee50671ccce25ad0e2.svg";
export { ForwardRef as ReactComponent };